module.exports = __webpack_public_path__ + "img/cloud-off-disabled.8899d7f4.svg";